import { AppState } from '../root-reducer';
import { ResourceTracking, TrackingState } from './definitions';

export const selectTrackingState = (state: AppState): TrackingState => state.trackingReducer;

export const selectResourceTracking = (state: AppState): ResourceTracking =>
  selectTrackingState(state).resourceTracking;

export const selectTrackingsLoading = (state: AppState): boolean => selectTrackingState(state).loading;
